import Navigation from 'app/Navigation';
import BaseObject from 'app/src/base/BaseObject';

export default class AuthValidator extends BaseObject {
  /**
   * Given an HTTP status code, this method will provide any default behaviour that should occur
   * in response to any authorization failure.  Currently, it only triggers a redirect to the login
   * page.
   *
   * @param {Number} statusCode   The HTTP status code of a failed API request.
   */
  static validateStatus(statusCode) {
    switch (statusCode) {
      // 401 should redirect to login
      case 401:
        Navigation.loginWithRedirect(Navigation.currentURL());
        break;

      default:
        break;
    }
  }
}
